import React, { useEffect } from "react";
import { MdSpaceDashboard } from "react-icons/md";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { BsFillTelephoneFill } from "react-icons/bs";
import { IoCloseOutline } from "react-icons/io5";
import { BsPlusLg } from "react-icons/bs";
import "../assets/css/agent/user-tabs.scss";
import { Link, useParams, useHistory } from "react-router-dom";
import axiosInstance from "../environment/axiosInstance";

function UsersTabs(props) {
  const url_params_string = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  let userId = url_params_string.indexOf("?") >= 0 ? url_params_string.substring(0, url_params_string.indexOf("?")) : url_params_string;
  const history = useHistory();

  useEffect(() => {
    axiosInstance
      .get(process.env.REACT_APP_API_URL + "/support/business_owner/customer/" + userId)
      .then(response => {
        if (response.data.statusCode == 200) {
          var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));

          if (!user_tabs) {
            var user_tab = {
              id: userId,
              name: response.data.Data?.customer_name,
              email: response.data.Data?.customer_email
            };

            localStorage.setItem("user_tabs", JSON.stringify([user_tab]));
          }
          else {
            var tab_exists = user_tabs.filter(tab => tab.id == userId);

            if (!tab_exists.length) {
              var user_tab = {
                id: userId,
                name: response.data.Data?.customer_name,
                email: response.data.Data?.customer_email
              };

              user_tabs.push(user_tab);

              localStorage.setItem("user_tabs", JSON.stringify(user_tabs));
            }
          }
        }
      });
  }, []);

  const closeTabClicked = (id) => {
    var user_tabs = JSON.parse(localStorage.getItem("user_tabs"));
    user_tabs = user_tabs.filter(tab => tab.id != id);

    if (user_tabs.length) {
      localStorage.setItem("user_tabs", JSON.stringify(user_tabs));
      history.push("/conversations/" + user_tabs[user_tabs.length - 1].id);
    }
    else {
      localStorage.removeItem("user_tabs");
      history.push("/dashboard");
    }
  }

  const onTabClicked = (id) => {
    history.push("/conversations/" + id);
  }

  return (
    <div className="d-flex user-tabs">
      <div
        onClick={() => history.push("/dashboard")}
        className={
          "d-flex align-items-center tab" +
          (
            window.location.href.includes("dashboard") ?
              " active"
              :
              ""
          )
        }
        style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }}
      >
        <MdSpaceDashboard
          size={24}
        />
        <p className="m-0 ms-1 user-name">My Dashboard</p>
      </div>
      {
        localStorage.getItem("user_tabs") && JSON.parse(localStorage.getItem("user_tabs"))?.map((tab, i) => {
          return (
            <>
              <div
                className={
                  "d-flex tab align-items-center"
                  + (
                    userId == tab.id ?
                      " active"
                      :
                      ""
                  )
                }>
                <div
                  onClick={() => onTabClicked(tab.id)}
                  className="d-flex align-items-center"
                  style={{ width: "100%" }}
                >
                  <div className="type-div">
                    <BsFillTelephoneFill
                      size={14}
                      color="green"
                    />
                  </div>
                  <div className="ms-2">
                    <p className="m-0 user-name">{tab.name}</p>
                    <div className="d-flex align-items-center">
                      <p className="m-0 status">Connected</p>
                    </div>
                  </div>
                </div>
                <IoCloseOutline
                  size={22}
                  className="ms-auto"
                  onClick={() => closeTabClicked(tab.id)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translate(0%, -50%)"
                  }}
                />
              </div>
              {
                userId != tab.id ?
                  <div className="border"></div>
                  :
                  <></>
              }
            </>
          )
        })
      }
    </div>
  )
}

export default UsersTabs;